module.exports = __webpack_public_path__ + "img/quest_icon_0030_coins.52ab9fec.png";